/**
 * The single seam between the card table and the variant engines.
 *
 * The renderer, hub, and game module import `VARIANTS` / `getVariant` from HERE
 * and nowhere else. This now points at the authoritative engines in `./engine`
 * (the interim engines have been removed).
 *
 * `VARIANTS` is an ordered array (the hub maps over it); `getVariant(id)` looks
 * one up. v1 exposes the two fully-wired variants — Klondike and FreeCell. The
 * engine layer also ships Spider, Pyramid, and TriPeaks, but their
 * variant-specific interaction (Spider's `dealRow`, Pyramid/TriPeaks
 * pair-removal) isn't wired into the renderer yet, so they are held back until
 * that interaction pass lands.
 */
import { freecell, klondike } from './engine';
import type { SolitaireVariant } from './engine/types';

/** Fully-wired variants, in hub order. The renderer drives each generically. */
export const VARIANTS: SolitaireVariant[] = [klondike, freecell];

export function getVariant(id: string): SolitaireVariant | undefined {
  return VARIANTS.find((v) => v.id === id);
}

export type { SolitaireVariant } from './engine/types';
